<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="articleAddForm" tag="form" class="d-flex flex-column"
                                  @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'title_l[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'title_l[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]"
                             :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'description_l[' + language.code + ']'" class="form-label">Description:</label>
                      <input :id="'description_l[' + language.code + ']'" class="form-control" :name="'description_l[' + language.code + ']'" v-model="formData.description_l[language.code]"
                             :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'heading_title_l[' + language.code + ']'" class="form-label">Heading title:</label>
                      <input :id="'heading_title_l[' + language.code + ']'" class="form-control" :name="'heading_title_l[' + language.code + ']'" v-model="formData.heading_title_l[language.code]"
                             :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'meta_title_l[' + language.code + ']'" class="form-label">Meta title:</label>
                      <input :id="'meta_title_l[' + language.code + ']'" class="form-control" :name="'meta_title_l[' + language.code + ']'" v-model="formData.meta_title_l[language.code]"
                             :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                      <label :for="'meta_description_l[' + language.code + ']'" class="form-label">Meta Description:</label>
                      <textarea :id="'meta_description_l[' + language.code + ']'" class="form-control" :name="'meta_description_l[' + language.code + ']'"
                                v-model="formData.meta_description_l[language.code]" :class="checkValidation(classes)" placeholder="meta description"></textarea>
                    </ValidationProvider>
                    <div class="d-flex justify-content-between align-items-center">
                      <h4>Content</h4>
                      <button type="button" @click="addContent" class="btn ripple btn-main-primary mt-2">Add Content
                      </button>
                    </div>
                    <div class="border-bottom mb-2 mt-3" v-for="(item, index) in formData.content_l" :key="index">
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`content_l[${index}].title[${language.code}]`" class="form-label d-flex justify-content-between align-items-center">
                          <span>Title:</span>
                          <button type="button" @click="removeContent(index)" class="btn ripple btn-main-primary radius" v-if="index > 0">
                            <i class="ti-close"></i>
                          </button>
                        </label>
                        <input :id="`content_l[${index}].title[${language.code}]`" class="form-control"
                               :name="`content_l[${index}][title][${language.code}]`"
                               v-model="formData.content_l[index].title[language.code]"
                               :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                      </ValidationProvider>
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`content_l[${index}].body[${language.code}]`" class="form-label">Body:</label>
                        <ckeditor :class="checkValidation(classes, language.code)"
                                  v-model="formData.content_l[index].body[language.code]"
                                  :name="`content_l[${index}].body[${language.code}]`"
                                  :id="`content_l[${index}].body[${language.code}]`"
                                  :config="ckEditorConfig"></ckeditor>
                      </ValidationProvider>
                    </div>
                  </b-tab>
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="code" class="form-label">Slug:</label>-->
<!--                    <input id="code" class="form-control" name="slug" v-model="formData.slug" placeholder="slug" :class="classes" type="text">-->
<!--                  </ValidationProvider>-->
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable"
                        :class="buttonDisable ? 'button-readonly' : ''">Submit
                </button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

const page = 'covid'
const url = 'covid'
export default {
  name: 'covid',
  data () {
    return {
      ckEditorConfig: {
        contentsLangDirection: 'ru',
        filebrowserImageUploadUrl: `${process.env.VUE_APP_WEB_API}editor/upload`,
        fileTools_requestHeaders: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.access_token}`
        }
      },
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      selectData: [],
      multipleFiles: [],
      articleCategory: [],
      tags: [],
      formData: {
        title_l: {},
        description_l: {},
        meta_title_l: {},
        meta_description_l: {},
        heading_title_l: {},
        content_l: [{
          title: {},
          body: {}
        }]
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData().then(res => {
        console.log(this.itemData)
        this.showVideo = true
        this.formData = this.itemData
      })
    }
  },
  methods: {
    ...mapActions({
      update: page + '/update',
      getData: page + '/getData'
    }),
    addContent () {
      this.formData.content_l.push({
        title: {},
        body: {}
      })
    },
    removeContent (i) {
      this.formData.content_l.splice(i, 1)
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.update(this.formData).then(() => {
            this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          }).finally(() => {
            this.buttonDisable = false
          })
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
